module.exports = __webpack_public_path__ + "static/media/BOR-BNB.872d024a.svg";